import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Button from '../../button/index';
import { DARK, ICON_ONLY } from '../../button/variants';
import Checkbox from '../../checkbox/index';
import { Download } from '../../../helpers/icon-dictionary';
import messages from '../messages';
import css from '../index.scss';

const RollOverInitial = (props) => {
    const {
        downloadSchoolRollDataRollover,
        intl,
        isDownloadingSchoolRollData,
        selectedProduct,
        showHelpModal,
        showSelectionPage,
        onIncludeUnassignedStudentsSelection,
        includeUnassignedStudents,
        onIncludeBulkTransferSelection,
        includeBulkTransfer
    } = props;
    const { name: productName } = selectedProduct;

    return (
        <div className={css.rollOverComponent}>
            <div className={css.header}>
                <div className={css.title}>
                    {intl.formatMessage(messages.header)}
                </div>
            </div>
            <div className={`${css.content} ${css.rollOverInitial}`}>
                <div className={css.contentWrapper}>
                    <div className={css.contentLabel}>
                        {intl.formatMessage(messages.initialTitle, { productName })}
                        <Button
                            buttonContainer={css.helpButtonContainer}
                            containerClassName={css.helpButton}
                            handleOnClick={showHelpModal}
                            label={intl.formatMessage(messages.buttonIcon)}
                        />
                    </div>
                    <div className={css.contentBody}>
                        <div className={css.listContainer}>
                            <div className={css.listItem}>
                                <span className={css.listItemBullet}>1</span>
                                {intl.formatMessage(
                                    messages.initialDownloadTemplate,
                                    { productName }
                                )}
                                <Button
                                    containerClassName={css.downloadButton}
                                    disabled={isDownloadingSchoolRollData}
                                    handleOnClick={() => {
                                        downloadSchoolRollDataRollover(
                                            selectedProduct.id,
                                            includeUnassignedStudents,
                                            includeBulkTransfer
                                        );
                                    }}
                                    icon={Download}
                                    variant={ICON_ONLY}
                                />
                            </div>
                            <div className={css.includeUnassigned}>
                                <Checkbox
                                    onclick={
                                        onIncludeUnassignedStudentsSelection
                                    }
                                />
                                {intl.formatMessage(messages.includeUnassigned)}
                            </div>
                            <div className={css.includeBulkTransfer}>
                                <Checkbox
                                    onclick={onIncludeBulkTransferSelection}
                                />
                                {intl.formatMessage(messages.includeBulkTransfer)}
                            </div>
                            <div className={css.listItem}>
                                <span className={css.listItemBullet}>2</span>
                                {intl.formatMessage(
                                    messages.initialUpdateSpreadsheet
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.rollOverFooter}>
                <Button
                    handleOnClick={showSelectionPage}
                    label={intl.formatMessage(messages.nextButton)}
                    variant={DARK}
                />
            </div>
        </div>
    );
};

RollOverInitial.propTypes = {
    downloadSchoolRollDataRollover: PropTypes.func,
    intl: intlShape.isRequired,
    isDownloadingSchoolRollData: PropTypes.bool,
    selectedProduct: PropTypes.object,
    showHelpModal: PropTypes.func,
    showSelectionPage: PropTypes.func,
    onIncludeUnassignedStudentsSelection: PropTypes.func,
    onIncludeBulkTransferSelection: PropTypes.func,
    includeUnassignedStudents: PropTypes.bool,
    includeBulkTransfer: PropTypes.bool
};

export default injectIntl(styleable(css)(RollOverInitial));



// WEBPACK FOOTER //
// ./app/components/roll-over/pages/initial.js